'use client';

import { safeStorage } from '@/app/utils/client';

const PHOTO_UPLOAD_TIPS_CONSENT_STORAGE_KEY = 'create_my_own_upload_tips_ack_v1';

function getPhotoUploadTipsConsentStorageKey(userId: string): string {
  return `${PHOTO_UPLOAD_TIPS_CONSENT_STORAGE_KEY}_${userId}`;
}

export function hasPhotoUploadTipsConsent(userId: string | undefined): boolean {
  if (!userId) {
    return true;
  }

  return safeStorage.getItem(getPhotoUploadTipsConsentStorageKey(userId)) === 'true';
}

export function savePhotoUploadTipsConsent(userId: string): void {
  safeStorage.setItem(getPhotoUploadTipsConsentStorageKey(userId), 'true');
}
